export default __webpack_public_path__ + "814e5cc55a7bfa624b27bc49a0339ff3.jpg";